import http from '../../../httpRequests.js';

export default {
    state() {
        return {
            url: 'services/request/proofreading',
        }
    },
    actions: {
        async orderProofreading(context, payload) {
            const response = await http.post(context.state.url, context.rootState.lang, payload, context.rootState.token);
            return response;
        }
    },
}